const API_BASE_URL = "https://api.novnat.co.uk/api"; // آدرس پایه API

export default API_BASE_URL;
